export default __webpack_public_path__ + "images/bda03539def390223b474c37044c46c1-camp_small.webp";